// extracted by mini-css-extract-plugin
module.exports = {"mCard":"se-z","image":"te-z","imageNoBackground":"ue-z"};